import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { changeTab } from "../__redux/slices/AppSlice";
import { MGLogo } from "../pages/Hero/Hero";
import { getEvents } from "./api/api";
import "./footer.scss";
import phoneIcon from "../assets/icons/phone.png";
import emailIcon from "../assets/icons/email.png";
import FBIcon from "../assets/icons/facebook.svg";
import adminIcon from "../assets/icons/admin-icon.png";

const TAB_NAMES = {
  Store: "Store",
  Services: "Services",
  Events: "Events",
  "About Us": "About Us",
};

const NAV_LINKS = [
  { to: "/store", label: "Store", tab: TAB_NAMES.Store },
  { to: "/services", label: "Rentals", tab: TAB_NAMES.Services },
  { to: "/events", label: "Events", tab: TAB_NAMES.Events, requiresEvents: true },
  { to: "/about", label: "About Us", tab: TAB_NAMES["About Us"] },
];

const Footer = () => {
  const dispatch = useDispatch();
  const [showEvents, setShowEvents] = useState(false);

  useEffect(() => {
    const checkForEvents = async () => {
      const events = await getEvents();
      setShowEvents(events.length !== 0);
    };
    checkForEvents();
  }, []);

  const handleNavClick = (tab) => {
    dispatch(changeTab(tab));
    window.scrollTo(0, 0);
  };

  const handleHomeClick = () => {
    dispatch(changeTab(undefined));
    window.scrollTo(0, 0);
  };

  const visibleNavLinks = NAV_LINKS.filter(
    (link) => !link.requiresEvents || showEvents
  );

  return (
    <footer id="footer" className="footer">
      <div className="footer-inner">
        <div className="footer-grid">
          <div className="footer-brand">
            <Link to="/" className="footer-logo-link" onClick={handleHomeClick}>
              <MGLogo logoPosition="stacked" />
            </Link>
          </div>

          <div className="footer-section">
            <h3 className="footer-heading">Explore</h3>
            <nav className="footer-nav" aria-label="Footer navigation">
              {visibleNavLinks.map(({ to, label, tab }) => (
                <Link
                  key={to}
                  to={to}
                  className="footer-btn"
                  onClick={() => handleNavClick(tab)}
                >
                  {label}
                </Link>
              ))}
            </nav>
          </div>

          <div className="footer-section">
            <h3 className="footer-heading">Contact</h3>
            <div className="footer-contact-list">
              <a href="tel:+19022379291" className="footer-contact-item">
                <img src={phoneIcon} alt="" aria-hidden="true" />
                <span>(902) 237-9291</span>
              </a>
              <a
                href="mailto:maplegrovepermaculture@gmail.com"
                className="footer-contact-item"
              >
                <img src={emailIcon} alt="" aria-hidden="true" />
                <span>maplegrovepermaculture@gmail.com</span>
              </a>
            </div>
          </div>

          <div className="footer-section">
            <h3 className="footer-heading">Connect</h3>
            <div className="footer-actions">
              <a
                className="footer-btn footer-btn--icon"
                href="https://www.facebook.com/people/Maple-Grove-Permaculture/100037322333641/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={FBIcon} alt="" aria-hidden="true" />
                <span>Facebook</span>
              </a>
              <Link to="/donate" className="footer-btn footer-btn--accent">
                Donate
              </Link>
              <Link to="/admin" className="footer-btn footer-btn--subtle">
                <img src={adminIcon} alt="" aria-hidden="true" />
                <span>Admin</span>
              </Link>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>
            &copy; {new Date().getFullYear()} Maple Grove Permaculture. All
            rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
